const styles = {
  background: 'rgba(0, 0, 0, 0.4)',
  width: '1000px',
  height: '270px',
  top: '132px',
  left: '50px',
  'z-index': '100000000',
  position: 'fixed',
  'font-size': '3.0rem',
  'white-space': 'pre',
}

const elementId = 'memoryLogger'

export function createMemoryLogger() {
  if (document.getElementById(elementId)) {
    return
  }
  const logger = document.createElement('div')
  logger.id = elementId
  Object.keys(styles).forEach((property) => {
    logger.style[property] = styles[property]
  })
  const rootElement = document.getElementById('root')
  rootElement.insertBefore(logger, rootElement.firstChild)

  const separateThousands = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  const average = (array) => {
    const filtered = array.filter((x) => x !== null)
    if (filtered.length === 0) {
      return 0
    }
    return filtered.reduce((a, b) => a + b) / filtered.length
  }

  const sizes = Array.from(Array(10)).map(() => null)

  const update = () => {
    const size = window.performance?.memory?.usedJSHeapSize || 0
    sizes.shift()
    sizes.push(size)
    render(
      separateThousands(size),
      separateThousands(average(sizes).toFixed(0))
    )
  }

  setInterval(() => {
    update()
  }, 5000)
  update()
}

function render(usage, movingAverage) {
  const logger = document.getElementById(elementId)
  if (logger) {
    logger.innerHTML = `usedJSHeapSize: ${usage}\nMoving Average: ${movingAverage}`
  }
}

export function setMemoryLoggerVisibility(visible) {
  const logger = document.getElementById(elementId)
  if (logger) {
    logger.style.visibility = visible ? 'visible' : 'hidden'
  }
}
